import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import TypeTextEditor from "../../form/TypeTextEditor";
import Collapse from "../../layout/Collapse";
import {connect} from "src/store";
import UrlField from "../../form/UrlField";
import NewLocationButton from "../NewLocationButton";
import ComponentField from "../../form/ComponentField";
import {isTrue} from "../../../utils/other";

class EventForm extends React.Component<any, any> {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    {!this.props.inline && <div className="col-md-2">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>}
                    {!this.props.inline && <div className="col-md-5">
                        <div className="form-group">
                            <Select
                                component="Program"
                                name="program"
                                value={this.props.values.program}
                                label="Program"
                                labelKey="name"
                                storeType="remote"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("program")}
                            />
                        </div>
                    </div>}
                    <div className="col-md-5">
                        <div className="form-group">
                            <label className="control-label">Helyszín(ek)</label>
                            <div className="input-group">
                                <Select
                                    component="location"
                                    name="locations"
                                    isMulti={true}
                                    value={this.props.values.locations}
                                    label={false}
                                    labelKey="name"
                                    storeType="local"
                                    order={[{field: "partner", direction: "DESC"}]}
                                    objectValue={true}
                                    filter={[
                                        {
                                            filters: [
                                                {
                                                    field: "partner",
                                                    value: this.props.partner.partner_id
                                                },
                                                {
                                                    field: "partner",
                                                    operator: "isnull"
                                                }
                                            ],
                                            operator: "OR"
                                        }
                                    ]}
                                    saveChanges={(field, value) => this.props.setFieldValue(field, Array.isArray(value) ? value.map((item) => ({id: item.id, name: item.name})) : value)}
                                    {...this.props.getFieldProps("locations")}
                                />
                                <div className="input-group-btn">
                                    <NewLocationButton
                                        saveChanges={(location) => {
                                            this.props.setFieldValue('locations', [...(this.props.values.locations || []), location.id])
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("from")}
                                name="from"
                                value={this.props.values.from}
                                label="Tól"
                                showTime={true}
                                maxDate={this.props.values.to}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("to")}
                                name="to"
                                value={this.props.values.to}
                                label="Ig"
                                showTime={true}
                                minDate={this.props.values.from}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    {!this.props.inline && <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="public"
                                value={this.props.values.public}
                                label="Publikus"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("public")}
                            />
                        </div>
                    </div>}
                    {this.props.values[this.props.componentConfig.idfield] && <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="canceled"
                                value={this.props.values.canceled}
                                label="Elmarad"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("canceled")}
                            />
                        </div>
                    </div>}
                    {!this.props.inline && !this.props.values[this.props.componentConfig.idfield] && <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="repeated"
                                value={this.props.values.repeated}
                                label="Többszöri esemény"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("repeated")}
                            />
                        </div>
                    </div>}
                </div>
                {!this.props.inline && this.props.values.public != 1 && <div className="row form-row">
                    <div className="col-md-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("expires_at")}
                            name="expires_at"
                            value={this.props.values.expires_at}
                            label="Automatikus törlés (ha nincs foglalás)"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>}
                {(!this.props.inline || (this.props.inline && !this.props.values?.program?.type?.preset?.dynamic)) && <Fragment>
                    {this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.url &&
                    <UrlField {...this.props}/>}
                    {!this.props.values.external_url && !this.props.values[this.props.componentConfig.idfield] && <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <CheckBox
                                    name="generate_url"
                                    value={this.props.values.generate_url}
                                    label="Url generálás"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>}
                    {!this.props.values.generate_url && this.props.componentConfig.fielddefs.external_url && <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="external_url"
                                values={this.props.values}
                                setFieldValue={(field, value) => this.props.setFieldValue(field, value ? value : null)}
                                label="Link"
                            />
                        </div>
                    </div>}
                </Fragment>}
                {this.props.values[this.props.componentConfig.idfield] && <Collapse collapsed={isTrue(this.props.values.canceled)}>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TypeTextEditor
                                name="canceled_description"
                                label="Elmaradás oka"
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                                getFieldProps={this.props.getFieldProps}
                                setFieldValue={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </Collapse>}
            </form>
        );
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(createForm(EventForm));
